import React from 'react';
import { Button, IconDownload } from '@screentone/core';

const ButtonExport = ({ action, disabled, children }) => (
  <Button tertiary icon={IconDownload} disabled={disabled} onClick={action}>
    {children}
  </Button>
);

export default ButtonExport;
